import {
  clearCandidateProfileDraft,
  readCandidateProfileDraft,
  saveCandidateProfileDraft,
} from "@/modules/candidate-personalization/services/profileDraft";
import type { TalentNetworkProfileDraft } from "../talentNetwork.types";

export function readTalentNetworkDraft(
  username: string,
): TalentNetworkProfileDraft | null {
  return readCandidateProfileDraft(username, "talent_network");
}

export function saveTalentNetworkDraft(
  username: string,
  draft: TalentNetworkProfileDraft,
) {
  saveCandidateProfileDraft(username, "talent_network", draft);
}

export function clearTalentNetworkDraft(username: string) {
  clearCandidateProfileDraft(username, "talent_network");
}
